import { token } from "@atlaskit/tokens";

import { Picture } from "@/components/wpl/image/src/index.ts";

export interface LoomAiTitleProps {
    planName: string;
}
export const LoomAiTitle = (props: LoomAiTitleProps) => {
    return (
        <span id={`pricing-plan-title-${props.planName}`}>
            {props.planName}
            <Picture
                image={{
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp",
                    alt: ""
                }}
                style={{
                    height: "17px",
                    width: "17px",
                    position: "relative",
                    insetInlineStart: token("space.025"),
                    insetBlockEnd: token("space.050")
                }}
            />
        </span>
    );
};
